<template>
  <section id="app-scan-qrcode">
    <v-btn
      v-if="!IS_DESKTOP"
      absolute
      right
      icon
      large
      @click="changeCamera"
    >
      <v-icon medium>
        flip_camera_android
      </v-icon>
    </v-btn>

    <bottom-action
      btn-del
      :btn-del-disabled="action === ActionEnum.credit"
      btn-cancel
      :btn-cancel-disabled="(action === ActionEnum.credit && total > 0)"
      :btn-valid="action === ActionEnum.credit"
      :btn-valid-disabled="action === ActionEnum.credit && total === 0"
      @del="$emit('del')"
      @cancel="$emit('cancel')"
      @valid="$emit('valid')"
    />
  </section>
</template>

<script>
import { CameraPositionEnum, CameraErrorEnum, IconEnum, ActionEnum } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'

export default {
  name: 'QrcodeScan',

  props: {
    action: { type: Number, default: null },
    resetScan: { type: Boolean, default: false },
    total: { type: Number, default: 0 }
  },

  data () {
    return {
      ActionEnum,
      IconEnum,
      IS_DESKTOP,
      //
      timeout: null,
      currentCamera: CameraPositionEnum.Back
    }
  },

  computed: {
    amount () { return this.$store.state.amount },
    useqrcodes () { return this.$store.state.useqrcodes },
    usenfc () { return this.$store.state.usenfc }
  },

  watch: {
    resetScan () {
      this.timeout = setTimeout(this.startQrScanner, 1800)
    }
  },

  mounted () {
    if (this.useqrcodes) {
      // Start Scanner
      this.startQrScanner()
    } else {
      this.toKeyboard()
    }
  },

  beforeDestroy () {
    this.stopQrScanner()
  },

  methods: {
    changeCamera () {
      this.currentCamera = this.currentCamera === CameraPositionEnum.Back
        ? CameraPositionEnum.Front
        : CameraPositionEnum.Back
      QRScanner.useCamera(this.currentCamera, this.onQrDone);
    },
    startQrScanner () {
      console.log('Start camera');
      // QRCode preparation / permissions
      // QRScanner.useCamera(this.currentCamera, this.onQrDone)
      QRScanner.prepare(this.onQrDone)
      // Hide background of app
      document.getElementById('inspire').style.background =
         'url("./background_qrcodes.png") 0% 0% / cover no-repeat, center center'
         document.documentElement.style.backgroundColor = 'transparent';
      },
    stopQrScanner () {
      // Suppression de la réactivation auto
      clearTimeout(this.timeout)
      this.timeout = null
      // Display app background
      document.getElementById('inspire').style.background =
        'linear-gradient(33deg, #444346, #90898e)'

        document.documentElement.style.backgroundColor = '#8e9090';
       
      // Hide camera reader
      QRScanner.hide((status) => {
        // console.log('hide', status)
        QRScanner.destroy((status) => {
          // console.log('destroy', status)
        })
      })
    },
    onQrDone (err, status) {
      if (err) {
        switch (err.code) {
          case CameraErrorEnum.BACK_CAMERA_UNAVAILABLE:
            $alert(this.$i18n.t('error.no_back_camera'))
            break
          case CameraErrorEnum.FRONT_CAMERA_UNAVAILABLE:
            $alert(this.$i18n.t('error.no_front_camera'))
            break
          case CameraErrorEnum.UNEXPECTED_ERROR:
          case CameraErrorEnum.CAMERA_ACCESS_DENIED:
          case CameraErrorEnum.CAMERA_ACCESS_RESTRICTED:
            // Open device settings for user accept
            $alert(this.$i18n.t('error.no_camera_accepted'), 'info', '', -1, [{
                title: this.$i18n.t('info.access_to_params'),
                color: 'success',
                click: () => {
                  QRScanner.openSettings()
                  this.$emit('del')
                }
              },{
                title: this.$i18n.t('info.change_scan_method'),
                color: 'info',
                click: () => {
                  this.$emit('to-scan-choice', this.$i18n.t('error.no_camera_available'), 1)
                }
              }],
              null,
              false
            )
            break
          case CameraErrorEnum.CAMERA_UNAVAILABLE:
            this.$emit('to-scan-choice', this.$i18n.t('error.no_camera'), 1)
            break
          case CameraErrorEnum.SCAN_CANCELED:
          case CameraErrorEnum.LIGHT_UNAVAILABLE:
          case CameraErrorEnum.OPEN_SETTINGS_UNAVAILABLE:
            break
        }
      }
        if (status) {
          if (status.authorized === true) {
            // Activate camera behind webview
            QRScanner.show()
            // Launch scan
            QRScanner.scan(this.getCode)
          } else if (status.denied === true) {
            // Open device settings for user accept
            QRScanner.openSettings()
          } else {
            // Redirection saisie manuelle avec désactivation du scanner
            this.toKeyboard(true)
          }
        }
    },
    getCode (err, code) {
      // Arrêt de la caméra
      this.stopQrScanner()
      if (err) {
        if (err.name !== 'SCAN_CANCELED') {
          // An error occurred
          $alert(err.name)
        }
      } else {
        // Fermeture d'un éventuelle alerte
        $alert(false)

        // Vibration
        if (!IS_DESKTOP) {
          navigator.vibrate(300)
        }

        this.$emit('scan', code.result ? code.result : code, 'QR')
      }
    },
    toKeyboard (disabledScanner = false) {
      if (disabledScanner) {
        // Désactivation QrCode
        this.$store.commit('useqrcodes', false)
        localStorage.setItem('useqrcodes', false)
        // Check type de scan par défaut
        if (this.$store.state.favoriteScan === 1) {
          this.$store.commit('favoriteScan', this.usenfc ? 0 : 2)
        }
      }
      this.$emit('to-keyboard', disabledScanner)
    }
  }
}
</script>
<style lang="scss">
#app-scan-qrcode{
  height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 5px);
  overflow: hidden;
  background-color: transparent;
}
</style>